import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { Injectable } from '@angular/core';
import { AuthService } from "./auth/auth.service";

@Injectable()

export class AuthInterceptor implements HttpInterceptor {
  constructor(private _auth: AuthService) {

  }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    req = req.clone({
      setHeaders: {
        //'Content-Type': 'application/json; charset=utf-8',
        //'Accept': 'application/json',
        'Authorization': `Bearer ${this._auth.getJwtToken()}`,
      },
    });

    return next.handle(req);
  }
}
